import Box from "./Box";
import Button from "./Button";
import CustomSelect from "./CustomSelect";
import LinkButtonSecondaryInner from "./LinkButtonSecondaryInner";
import React from "react";

function BlogListFilters({ categories, current, setCurrent }) {
  return (
    <>
      <Box display={["none", null, "block", null]}>
        <Button
          onClick={() => {
            if (current) setCurrent(null);
          }}
          mb="1px"
        >
          <LinkButtonSecondaryInner
            bg="black"
            color="white"
            text="All"
            active={!current}
          />
        </Button>
        {categories.map((category) => {
          const active = current === category;
          return (
            <Button
              key={category}
              onClick={() => {
                if (!active) setCurrent(category);
              }}
              mb="1px"
            >
              <LinkButtonSecondaryInner
                bg="black"
                color="white"
                text={category}
                active={active}
              />
            </Button>
          );
        })}
      </Box>
      <Box display={["block", null, "none", null]}>
        <CustomSelect
          items={categories}
          defaultText="All"
          value={current ? current : ""}
          handleChange={(item) => {
            setCurrent(item);
          }}
        />
      </Box>
    </>
  );
}

export default BlogListFilters;
